/* eslint-disable no-case-declarations */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import metadata from './MLPUPExcludedLocationsComponent.metadata.json5';
import './MLPUPExcludedLocationsComponent.messages';

// Component is only shown in read only
function MLPUPExcludedLocationsComponent(props) {
    const {
        items,
        getTypeKeyDescription,
        getYesNoAnswer
    } = props;

    const viewModelService = useContext(ViewModelServiceContext);
    const locationTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('PUPLocationType_PUE');

    const generateItemOverrides = () => {
        const itemOverrides = items.map((item, itemIndex) => {
            return {
                [`addressContent${itemIndex}`]: {
                    content: `${item.address.addressLine1}, ${item.address.city}, ${item.address.state}`
                },
                [`excludedContent${itemIndex}`]: {
                    content: getYesNoAnswer(item.isExcluded)
                },
                [`typeContent${itemIndex}`]: {
                    content: getTypeKeyDescription(locationTypelist.getCode(item.locationType).name)
                }
            };
        });

        return Object.assign({}, ...itemOverrides);
    };

    const overrides = {
        tableRowIterable: {
            data: items
        },
        ...generateItemOverrides()
    };
    const resolvers = {};

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

MLPUPExcludedLocationsComponent.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    getTypeKeyDescription: PropTypes.func.isRequired,
    getYesNoAnswer: PropTypes.func.isRequired
};

export default MLPUPExcludedLocationsComponent;
